<script>
  export let iscorrect;
  import Confetti from "./Confetti.svelte";
  import { fade } from "svelte/transition";
  const ANSWER_DELAY = 1000;
</script>

<div
  class="w-100 h-100 z-4 absolute top-0 left-0 flex items-center justify-center {iscorrect
    ? 'bg-custom-green'
    : 'bg-custom-gray'}"
  transition:fade={{ delay: ANSWER_DELAY }}
>
  {#if iscorrect}
    <Confetti durationInSeconds={2} delay={ANSWER_DELAY} timeout={3000} />
  {/if}
  <p class="f3 w-100 tc ml3 mr3">
    {iscorrect ? "Bonne réponse" : "Mauvaise réponse"}
  </p>
</div>
